import { render } from "./ConfigSys.vue?vue&type=template&id=b1160cd0&scoped=true"
import script from "./ConfigSys.vue?vue&type=script&lang=js"
export * from "./ConfigSys.vue?vue&type=script&lang=js"

import "./ConfigSys.vue?vue&type=style&index=0&id=b1160cd0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1160cd0"]])

export default __exports__